import {ID, Response} from '../../../../../../../_metronic/helpers'
export type User = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  username?: string
  firstname?: string
  lastname?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}

export interface IUsers {
  id?: ID
  uuid?: string
  username?: string
  firstname?: string
  lastname?: string
  email?: string
  password?: string
  confirm_password?: string
  device_name?: string
}

export const UsersInitValues: IUsers = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  confirm_password: '',
  device_name: '',
}

export interface Licenses {
  file?: string
  parent_id?: number[]

  description?: string
  license_number?: string
  issue_organ?: {
    name: string
  }

  issue_date?: string
  expiration_date?: string
  limit_renovation?: string
  status?: string

  licenseAlertDay?: [
    {
      id?: number
      renovation_alert_day?: number
    }
  ]

  fields?: [
    {
      name: string
      id: number
    }
  ]

  project?: {
    code: string
    id: number
  }

  license_type?: {
    abbreviate: string
  }

  licenseType?: {
    id: number
    abbreviate: string
  }

  entrepreneur?: {
    id: number
    name: string
  }
  enterprises?: [
    {
      id: number
      name: string
    }
  ]
  parentsLicense?: [
    {
      id?: number
    }
  ]

  enterprises_type?: {
    abbreviate: string
  }

  issueOrgan?: {
    id?: number
    abbreviate?: string
    description?: string
  }

  document?: string
  code?: string
  id?: number
  uuid?: string
  name?: string

  coordinator_id?: number
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }

  control_conditionings?: boolean
  change_ownership?: boolean
  copy_conditions?: boolean
  renovation_request_date?: string
  finalization_date?: string

  issue_cost?: string
  renovation_cost?: string
  maintenance_cost?: string
  responsible?: string

  responsibles?: [
    {
      id?: number
    }
  ]

  activity_log?: [
    {
      causer: {
        active?: true
        email?: string
        firstname?: string
        id?: number
        lastname?: string
        pic?: string
        username?: string
        uuid?: string
      }
      description?: string
      properties?: {
        attributes?: {status?: string; file?: string; license_number?: string; issue_date?: string}
        old?: {status: string}
      }
    }
  ]
}

export type LicensesQueryResponse = Response<Array<Licenses>>

export const LicensesInitValues: Licenses = {
  description: '',
  role: 'Administrator',
}
